import React, { useState, useEffect } from 'react';

const BACKEND_URL = '';

const Gallery = () => {
  const [galleryImages, setGalleryImages] = useState([]);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/images`);
        if (response.ok) {
          const images = await response.json();
          // Filter for gallery category images
          const galleryOnly = images.filter(img => img.category === 'gallery');
          if (galleryOnly.length > 0) {
            setGalleryImages(galleryOnly);
          } else {
            // Default gallery images if none uploaded
            setGalleryImages([
              { id: '1', url: 'https://images.pexels.com/photos/701877/pexels-photo-701877.jpeg?auto=compress&cs=tinysrgb&w=800', title: 'Designer Sunglasses', photographer: 'Studio Collection' },
              { id: '2', url: 'https://images.pexels.com/photos/975668/pexels-photo-975668.jpeg?auto=compress&cs=tinysrgb&w=800', title: 'Premium Frames', photographer: 'European Brands' },
              { id: '3', url: 'https://images.pexels.com/photos/1068735/pexels-photo-1068735.jpeg?auto=compress&cs=tinysrgb&w=800', title: 'Luxury Eyewear', photographer: 'Italian Design' },
            ]);
          }
        }
      } catch (error) {
        console.error('Error fetching gallery:', error);
        // Use defaults on error
        setGalleryImages([
          { id: '1', url: 'https://images.pexels.com/photos/701877/pexels-photo-701877.jpeg?auto=compress&cs=tinysrgb&w=800', title: 'Designer Sunglasses', photographer: 'Studio Collection' },
          { id: '2', url: 'https://images.pexels.com/photos/975668/pexels-photo-975668.jpeg?auto=compress&cs=tinysrgb&w=800', title: 'Premium Frames', photographer: 'European Brands' },
          { id: '3', url: 'https://images.pexels.com/photos/1068735/pexels-photo-1068735.jpeg?auto=compress&cs=tinysrgb&w=800', title: 'Luxury Eyewear', photographer: 'Italian Design' },
        ]);
      }
    };
    fetchGallery();
  }, []);

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Designer Brands From Italy, Paris, England, Canada & More!
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {galleryImages.map((image) => (
            <div 
              key={image.id}
              className="group relative overflow-hidden rounded-xl shadow-lg"
            >
              <img 
                src={image.url.startsWith('/api') ? `${BACKEND_URL}${image.url}` : image.url} 
                alt="Gallery image"
                className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
